import zh from './locales/zh';
import en from './locales/en';
import vi from './locales/vi';

const resources = {
  zh: { translation: zh },
  en: { translation: en },
  vi: { translation: vi },
  vn: { translation: vi }
};

export default resources;
